import React from 'react';
import PropTypes from 'prop-types';

import { PriceHistoryPopup } from '../../../../Price/index';
import { Price as FinancePrice } from '../../../../../classes/finance/index';
import { fixedPrice } from '../../../../../utils/formater';
import { SALE } from '../../../../../consts';

function PriceTotal (props) {
  /** @var Announcement */
  const item = props.item;

  const priceInfo = FinancePrice.getPriceInfo(item);
  const priceHistory = item.getPriceHistory();

  const deal = item.getDeal();

  const getLabel = () => (item.getDealType() === SALE ? 'продан' : 'сдан') + ' по цене:';

  const getSoldPrice = () => {
    const price = priceInfo.priceValue;
    const priceSold = deal.getPrice().getValue();

    if (price === priceSold) {
      return (
        <div className='deal'>
          <div className='deal-label'>{getLabel()}</div>
          <span className='main-param'>
            {priceInfo.price}
          </span>
        </div>
      );
    }

    return (
      <div className='deal price-diff'>
        <div className='original-deal'>
          <span className='main-param'>
            {priceInfo.price}
          </span>
        </div>

        <div className='result-deal'>
          <div className='deal-label'>{getLabel()}</div>
          <span className='main-param'>
            { deal.getPrice().getLabel() }
          </span>
          <div className={'inequality-price ' + (priceSold - price > 0 ? 'plus' : 'minus')}>
            { fixedPrice(priceSold - price) }
          </div>
        </div>
      </div>
    );
  };

  const getCurrentPrice = () => {
    return (
      <div>
        <PriceHistoryPopup
          history={priceHistory}
          dealType={item.getDealType()}
          realtyType={item.getRealtyType()}
          realtyId={item.getProperty().getId()}
        >
          <span className='main-param'>
            {priceInfo.price}
          </span>
        </PriceHistoryPopup>
      </div>
    );
  };

  return (
    <td className='paper col-price'>
      {
        deal ? getSoldPrice() : getCurrentPrice()
      }
    </td>
  );
}

PriceTotal.propTypes = {
  item: PropTypes.object.isRequired
};

export default PriceTotal;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/Cells/PaperCells/PriceTotal.jsx